import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment-timezone';

const timezone = moment.tz.guess();

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    TimeZoneId: timezone,
    'Access-Control-Allow-Origin': '*',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateService {
  API_RATE: string = environment.apiRate;

  constructor(private http: HttpClient, private router: Router) {}

  loadExchangeRate(): Observable<any> {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*');

    if (timezone) {
      headers = headers.append('TimeZoneId', timezone);
    }
    return this.http.get(
      this.API_RATE + 'exchangerate/getexchangerate?platForm=WEB',
      { headers }
    );
  }

  public loadExchangeRateWithFeesByReceptionMethod(
    param: any
  ): Observable<any> {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*');

    if (timezone) {
      headers = headers.append('TimeZoneId', timezone);
    }
    return this.http.post(
      this.API_RATE + 'exchangerate/getexchangerate/transferFees/benemethod',
      param,
      { headers }
    );
  }
}
